import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { noWhitespace } from '../../validators/no-whitespace.validator';

@Component({
  selector: 'app-add-action-card-dialog',
  templateUrl: './add-action-card-dialog.component.html',
  styleUrls: ['./add-action-card-dialog.component.css']
})
export class AddActionCardDialogComponent implements OnInit {

  cardForm: FormGroup = new FormGroup({
    cardAction: new FormControl('', [Validators.required, noWhitespace]),
  });

  constructor() { }

  ngOnInit(): void {
  }

}
